<template>
  <div class="menu-manage">
    <!-- 菜单管理 -->
    <div class="top-buttons">
      <el-button circle plain type="warning" icon="el-icon-s-unfold" @click="expandOrNot(true)" title="展开菜单"></el-button>
      <el-button circle plain type="primary" icon="el-icon-s-fold" @click="expandOrNot(false)" title="折叠菜单"></el-button>
      <el-button circle plain type="success" icon="el-icon-edit" title="添加菜单"
        @click="handleNewMenuItem(undefined,{id:0,label:'根菜单'})"></el-button>
      <el-button circle plain type="info" icon="el-icon-refresh" @click="handleInit" title="刷新"></el-button>
    </div>
    <div class="menu-tree">
      <!-- <p>使用 scoped slot</p> -->
      <el-tree v-loading="menu_tree_loading" :data="menu_data" show-checkbox node-key="id" :default-expand-all="false"
        draggable ref="treeX" :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <!-- <div class="menu-item"> -->
          <span>{{ node.label }}</span>
          <span>
            <!-- v-if="data.children!=undefined&&data.children.length!=0 || data.parentid == 0 && data.url == ''" -->
            <el-button plain type="success" size="mini" @click="() => handleNewMenuItem(node,data)">
              新建
            </el-button>
            <el-button plain type="danger" size="mini" @click="() => handleRemoveMenuItem(node, data)">
              删除
            </el-button>
            <el-button plain type="primary" size="mini" @click="() => handleEditMenuItem(node, data)">
              编辑
            </el-button>
          </span>
          <!-- </div> -->
        </span>
      </el-tree>
    </div>

    <!-- Dialog -->
    <el-dialog title="新建菜单" :visible.sync="dialogNewVisible"  >
      <el-form :model="newMenuItem" ref="newMenuItem" :rules="newMenuItemRules">
        <el-form-item label="菜单名称" :label-width="formLabelWidth" prop="name">
          <!-- v-model="newMenuItem.name" autocomplete="off" -->
          <el-input :value="newMenuItem.name"
            @input="e => newMenuItem.name = e.replace(/[^a-zA-Z\u4e00-\u9fa5\d]+$/g,'')" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="根菜单" :label-width="formLabelWidth">
          <el-input v-model="newMenuItem.parentName" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="页面地址" :label-width="formLabelWidth" prop="url">
          <!--  v-model="newMenuItem.url" autocomplete="off" placeholder='地址格式("/"+页面地址,根目录可置空)' /[\s+]/g-->
          <el-input :value="newMenuItem.url" @input="e => newMenuItem.url = e.replace(/[^/a-zA-Zd]+$/g,'')"
            maxlength="20" placeholder='地址格式("/"+页面地址)'></el-input>
        </el-form-item>
        <el-form-item label="图标" :label-width="formLabelWidth" prop="icon">
          <!--  v-model="newMenuItem.icon" autocomplete="off" -->
          <el-input :value="newMenuItem.icon" @input="e => newMenuItem.icon = e.replace(/[^A-Za-z-\s]/g,'')"
            maxlength="20" placeholder="fa fa-user"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogNewVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmNew">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑菜单" :visible.sync="dialogEditVisible"  >
      <el-form :model="editMenuItem" ref="editMenuItem" :rules="editMenuItemRules">
        <el-form-item label="菜单名称" :label-width="formLabelWidth" prop="name">
          <!-- v-model="editMenuItem.name" autocomplete="off" -->
          <el-input :value="editMenuItem.name"
            @input="e => editMenuItem.name = e.replace(/[^a-zA-Z\u4e00-\u9fa5\d]+$/g,'')" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="页面地址" :label-width="formLabelWidth" prop="url">
          <!-- v-model="editMenuItem.url" autocomplete="off" -->
          <el-input :value="editMenuItem.url" @input="e => editMenuItem.url = e.replace(/[\s+]/g,'')" maxlength="20">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    allMenuItem
  } from '@/api/menu'
  import {
    addMenuItem
  } from '@/api/menu'
  import {
    updateMenuItem
  } from '@/api/menu'
  import {
    deleteMenuItem
  } from '@/api/menu'

  export default {
    name: 'MenuManage',
    data() {
      var validateUrl = (rule, value, callback) => {
        let r = /^[a-zA-Z-/]*$/; //   /^\/.*$/;
        if (!r.test(value)) {
          callback(new Error('地址格式("/"+页面地址)'));
        }
        callback();
      };
      return {
        roleId: '',
        menu_data: [],
        menu_tree_loading: true,
        formLabelWidth: '120px',
        // 新建菜单
        newMenuItem: {
          name: '',
          parentName: '',
          parentid: 0,
          url: '',
          icon: 'fa fa-user',

        },
        dialogNewVisible: false,
        newMenuItemRules: {
          name: [{
            required: true,
            message: '请输入菜单名称',
            trigger: 'blur'
          }, ],
          url: [{
              required: false,
              message: '请输入Url',
              trigger: 'blur'
            },
            {
              validator: validateUrl,
              trigger: 'blur'
            }
          ],
          icon: [{
            required: true,
            message: '请输入Icon名称',
            trigger: 'blur'
          }, ]
        },
        // 编辑菜单
        editMenuItem: {
          id: 0,
          name: '',
          url: '',
          icon: '',
          parentid: '',
        },
        dialogEditVisible: false,
        editMenuItemRules: {
          name: [{
            required: true,
            message: '请输入菜单名称',
            trigger: 'blur'
          }, ],
          url: [{
              required: false,
              message: '请输入Url',
              trigger: 'blur'
            },
            {
              validator: validateUrl,
              trigger: 'blur'
            }
          ],
        }
      }
    },
    methods: {
      /**
       * 数据初始化
       */
      handleInit() {
        this.menu_tree_loading = true
        allMenuItem(this.$store.getters['user/roleId']).then(res => {
          if (res.result === "0") {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.dialogNewVisible = false
          } else {
            this.$message.error(res.message)
          }
          this.menu_data = this.menuDataTrans(res.menu).children
          console.log(this.menu_data)
          this.menu_tree_loading = false
        })
      },

      /**
       * @param {Object} done
       * 点击新建框外提示
       */
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      menuDataTrans(item) {
        let res = {
          icon: item.cur.icon,
          id: item.cur.id,
          label: item.cur.name,
          parentid: item.cur.parentid,
          url: item.cur.url,
          children: []
        }
        for (let child of item.children) {
          res.children.push(this.menuDataTrans(child))
        }
        return res
      },
      expandOrNot(isexpand) {
        for (var i = 0; i < this.$refs.treeX.store._getAllNodes().length; i++) {
          this.$refs.treeX.store._getAllNodes()[i].expanded = isexpand;
        }
      },
      async handleNewMenuItem(node, data) {
        if (await this.handleConfirm('将在"' + data.label + '"菜单下增加子菜单')) {
          this.newMenuItem.parentName = data.label
          this.newMenuItem.parentid = data.id
          this.dialogNewVisible = true
          this.newMenuItem.name = ''
          this.newMenuItem.url = ''
        }
      },
      confirmNew() {
        this.$refs.newMenuItem.validate(valid => {
          if (!valid) {
            this.$message({
              type: 'info',
              message: '检查输入'
            });
          } else {
            addMenuItem(this.roleId, this.newMenuItem).then(res => {
              if (res.result === "0") {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.dialogNewVisible = false
                this.handleInit()
              } else {
                this.$message.error(res.message)
              }
            })
          }
        })
      },
      handleEditMenuItem(node, data) {
        this.editMenuItem.id = data.id
        this.editMenuItem.name = data.label
        this.editMenuItem.url = data.url
        this.editMenuItem.icon = data.icon
        this.editMenuItem.parentid = data.parentid
        this.dialogEditVisible = true
      },
      confirmEdit() {
        this.$refs.editMenuItem.validate(valid => {
          if (!valid) {
            this.$message({
              type: 'info',
              message: '检查输入'
            });
          } else {
            updateMenuItem(this.roleId, this.editMenuItem).then(res => {
              if (res.result === "0") {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.dialogEditVisible = false
                this.handleInit()
              } else {
                this.$message.error(res.message)
              }
            })
          }
        })
      },
      async handleRemoveMenuItem(node, data) {
        this.editMenuItem.id = data.id
        this.editMenuItem.name = data.label
        this.editMenuItem.url = data.url
        this.editMenuItem.icon = data.icon
        this.editMenuItem.parentid = data.parentid
        if (await this.handleConfirm("确定删除" + data.label)) {
          if (data.url != "" || data.children.length != 0) {
            this.$message({
              type: 'info',
              message: '指定了Url或者有子菜单的菜单项不能被删除！'
            })
            return
          }
          deleteMenuItem(this.roleId, this.editMenuItem).then(res => {
            if (res.result === "0") {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.handleInit()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      async handleConfirm(message) {
        let res = true
        await this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          res = true
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
          res = false
        });
        return res
      },
    },
    mounted() {
      this.roleId = this.$store.getters['user/roleId']
      this.handleInit()
    }
  }
</script>

<style>
  .el-tree-node__content {
    /* background: #F5F8FA; */
    height: 50px;
  }

  /* .menu-manage {
    padding-left: 10px;
    padding-top: 10px;
} */

  .top-buttons {
    padding-left: 50px;
    padding-bottom: 10px;
  }

  .menu-tree {
    width: 95%;
    padding-bottom: 50px;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    height: 40px;
    padding-left: 10px;
  }


  .menu-item {}
</style>
